export enum Rotation {
  NoRotation0 = 0,
  Clockwise90 = 1,
  UpsideDown180 = 2,
  Clockwise270 = 3
}
